'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _debounce3 = require('lodash/debounce');

var _debounce4 = _interopRequireDefault(_debounce3);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.default = sessionMiddleware;

var _auth = require('redux/modules/auth');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _notSessionActions = require('../modules/not-session-actions');

var notSessionActions = _interopRequireWildcard(_notSessionActions);

var _reactRouterRedux = require('react-router-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Session timeout middleware - logout on timeout */

var sessionTimer = null;

function getNotSessionActions() {
  var res = [];
  (0, _values2.default)(notSessionActions).map(function (actions) {
    res = [].concat((0, _toConsumableArray3.default)(res), (0, _toConsumableArray3.default)(actions));
  });
  return res;
}

var notSessionActionsArray = getNotSessionActions();

var timeoutFn = (0, _debounce4.default)(function (_ref) {
  var dispatch = _ref.dispatch,
      timeout = _ref.timeout;

  var t = require('i18n-universal').getT();
  sessionTimer = setTimeout(function () {
    dispatch((0, _auth.logout)(true)).promise.then(function () {
      return _toastr2.default.info(t('Session timeout. Please login again.'));
    });
  }, timeout * 1000);
}, 1000);

function sessionMiddleware() {
  return function (_ref2) {
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }

        if (action.type === _auth.LOGOUT) {
          dispatch((0, _reactRouterRedux.push)('/'));
        }

        var user = (0, _get4.default)(getState(), 'auth.user');
        var timeout = (0, _get4.default)(user, 'rightMngt.sessionTimeout', 0);

        if (!user) {
          clearTimeout(sessionTimer);
        }

        if (timeout && !notSessionActionsArray.includes(action.type)) {
          // console.log('set session timer', timeout, action.type);
          clearTimeout(sessionTimer);
          timeoutFn({ dispatch: dispatch, timeout: timeout });
        }

        next(action);
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/sessionMiddleware.js
// module id = 2234
// module chunks = 1